import axiosInstance from "../../../api/axiosInstance";

// ===== CATEGORIES =====
export const fetchCategories = async (params = {}) => {
 try {
 const cleaned = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
 const res = await axiosInstance.get("/public/daily-sentences/categories", { params: cleaned });
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};

export const fetchCategoryById = async (id) => {
 try {
 const res = await axiosInstance.get(`/public/daily-sentences/categories/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};

// ===== SENTENCES =====
export const fetchDailySentences = async (params) => {
 try {
 const cleaned = Object.fromEntries(
 Object.entries(params).filter(([, v]) => v !== "" && v != null)
 );
 const res = await axiosInstance.get("/public/daily-sentences", { params: cleaned });
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};

export const fetchDailySentenceById = async (id) => {
 try {
 const res = await axiosInstance.get(`/public/daily-sentences/${id}`);
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
 }
};

// ===== OPTIONS =====
export const fetchSentenceOptions = async () => {
 try {
 const res = await axiosInstance.get("/public/daily-sentences/options");
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch options" };
 }
};
